let logoutInProgress = false

export function beginLogoutSessionCleanup() {
  logoutInProgress = true
}

export function clearLogoutSessionCleanup() {
  logoutInProgress = false
}

export function isLogoutInProgress() {
  return logoutInProgress
}
